export default __webpack_public_path__ + "static/media/031-hearse.9455e3f3.svg";